import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Injector, OnInit } from '@angular/core';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { saveAs } from 'file-saver';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home-quick-search-popup',
  templateUrl: './home-quick-search-popup.component.html',
  styleUrls: ['./home-quick-search-popup.component.scss'],
})
export class HomeQuickSearchPopupComponent  implements OnInit {
  statusCheck: any;
  fileName:any = null;
  fileType:any = null;
  formData:any = new FormData();
  letterHeadUrl:any;
  isFileSizeIsInvalid:boolean = false;
  loggedInUserCompanyID:any;
  searchEmployee:any
  getEmployeeSearchData:any = [];
  buttonColorName:any;
  showBrowseBtn: boolean = false;
  handbookFileData:any = [];
  isShowUploadUserManual:any = false;
  loggedInUserRole:any;
  isDisabledUploadPolicyBtn:boolean = true;

  constructor(private injector: Injector,  private httpService: HttpService, private config: Config,
    private encryptionService: EncryptionService, private datePipe: DatePipe, public dialog: MatDialog,
    private sanitizer: DomSanitizer, private http:HttpClient
  ) {
  }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    const dialogData = this.injector.get(MAT_DIALOG_DATA);    
    this.statusCheck = dialogData.statusCheck;
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if(this.statusCheck == 'employeeSearch'){
      this.getEmployeeSearch()
    }
    this.getHrHandBookFileData()
  }

  ionViewWillEnter(){
  }

  getEmployeeSearch(){
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "entityName": null,
      "search": this.searchEmployee || null,
      "status": 1,
      "userType": null
    }
    this.httpService.callPostService(this.config.searchEmployeeMaster, request).subscribe((result:any)=>{
      this.getEmployeeSearchData = result.data.users
    })
  }

  onEmployeeSearch(data:any){
    var search = ''
    this.searchEmployee = data;
    if (data == '') {
      this.searchEmployee = null;
      this.getEmployeeSearch();
      return;
    }
    if (data.length > 1) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getEmployeeSearch();
          },
            500);
        }
      },
        1500);
    }
  }

  
  triggerFileInput() {
    const fileInput:any = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }

  // onFileSelected(event: Event) {
  //   const inputEvent:any = event.target as HTMLInputElement;
  //   this.fileName = null;
  //   this.fileType = null;
  //   this.formData = new FormData();
  //   // const fileSizeInKB = inputEvent.files[0].size / 1024;
  //   // const fileSizeInMB = fileSizeInKB / 1024;    
  //   if (!inputEvent.files[0] || inputEvent.files[0].length == 0) {
  //     return;
  //   }
  //   if (inputEvent.files[0].name.includes('csv') && !inputEvent.files[0].name.includes('CSV') && !inputEvent.files[0].name.includes('xlsx') && !inputEvent.files[0].name.includes('XLSX')) {
  //     window.alert("File format is not supported");
  //     return;
  //   }
  //   // if (fileSizeInMB > 10) {
  //   //   window.alert("File size is greater than 10MB");
  //   //   return;
  //   // }
  //     if (inputEvent.files[0]) {
  //       this.fileName = inputEvent.files[0].name;
  //       this.fileType = inputEvent.files[0].type;
  //       this.formData = new FormData();
  //       this.formData.append('file', inputEvent.files[0]);
  //       this.formData.append('companyId', this.loggedInUserCompanyID);
  //       this.showBrowseBtn = true;
  //       this.isFileSizeIsInvalid = false;
  //       const url = this.config.uploadFileLocally + `?fileName=${this.fileName}&fileType=${this.fileType}`;
  //       this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
  //         this.letterHeadUrl=data?.data;
  //       })
  //     }
  // }

  onClickShowUploadUserManual(){
    this.isShowUploadUserManual = !this.isShowUploadUserManual
  }

  onFileSelected(event: Event) {
    const inputEvent: any = event.target as HTMLInputElement;
    this.fileName = null;
    this.fileType = null;
    this.formData = new FormData();
    if (!inputEvent.files || inputEvent.files.length === 0) {
      return;
    }
    const selectedFile = inputEvent.files[0];
    const fileName = selectedFile.name.toLowerCase();
    const fileType = selectedFile.type;
    const supportedFormats = ['png', 'jpeg', 'jpg', 'pdf', 'XLSX', 'xlsx'];
    const fileExtension = fileName.split('.').pop();
    if (!supportedFormats.includes(fileExtension)) {
      window.alert("File format is not supported. Please upload png, jpeg, jpg, excel or pdf.");
      return;
    }
    this.fileName = selectedFile.name;
    this.fileType = selectedFile.type;
    this.formData = new FormData();
    this.formData.append('file', selectedFile);
    this.formData.append('companyId', this.loggedInUserCompanyID);
    this.showBrowseBtn = true;
    this.isDisabledUploadPolicyBtn = false;
    this.isFileSizeIsInvalid = false;
    const url = this.config.uploadFileLocally + `?fileName=${this.fileName}&fileType=${this.fileType}`;
    this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
      this.letterHeadUrl = data?.data;
    });
  }

  //  code for Help Desk

  onClickOpenTickets(){
    const tickets = `https://wwwcatalystdevphiedgecoin.raiseaticket.com/support/#/newticket`
    window.open(tickets, '_blank')
  }

  onClickSaveUserManualFile(){
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'File is uploaded.',
        btn2: 'Done',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe((result:any) => {
     if(result){
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fileName": this.fileName,
        "id": null,
        "url": this.letterHeadUrl
      }
      this.httpService.callPostService(this.config.setUserManual, request).subscribe((result:any)=>{
        this.showBrowseBtn = false;
        this.isDisabledUploadPolicyBtn = false;
      })
     }
    });
  }

  downloadUserManual(){
    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((result:any)=>{
      const downloadFile:any = result?.data;  
    if(downloadFile.userManualUrl){
      var filename= downloadFile.userManualUrl.split(environment.downloadURL)
      saveAs(downloadFile.userManualUrl, filename[1]);  
      // saveAs(environment.downloadURL+downloadFile.userManualUrl,downloadFile.userManualUrl);

    }
    })
  }

  onCloseFile(){
    this.showBrowseBtn = false;
    this.isDisabledUploadPolicyBtn = false;
  }

  onClickSaveHrHandbookFile(){
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'File is uploaded.',
        btn2: 'Done',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fileName": this.fileName,
        "id": null,
        "url": this.letterHeadUrl
      }
      this.httpService.callPostService(this.config.setHrHandbook, request).subscribe((result:any)=>{
        if(result){
          this.getHrHandBookFileData();
          this.showBrowseBtn = false;
        }
      })
    });
  }

  getHrHandBookFileData(){
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "search": this.searchEmployee
    }
    this.httpService.callPostService(this.config.getByCompanyIdHrHandbook, request).subscribe((result:any)=>{
      this.handbookFileData = result.data.map((ele:any)=>({
        id:ele.id,
        handbookFileName: ele.handbookFileName,
        handbookUrl:ele.handbookUrl
      }));
    })
  }

  viewHandBookFile(handbookUrl: string, fileName: string) {
    window.open(handbookUrl, '_blank');

  }
  
  downloadHandBookFile(handbookUrl:any, fileName:any){ 
      if(handbookUrl){
        saveAs(handbookUrl, fileName);  
      }
  }

  onClickDeleteHandbookFile(id:any){
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to delete',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.httpService.callGetService(this.config.deleteHrHandbook + id).subscribe((result)=>{
          if(result){
            this.getHrHandBookFileData();
          }
        })
      }
    });

  }

  onHandbookFileSearch(data:any){
    var search = ''
    this.searchEmployee = data;
    if (data == '') {
      this.searchEmployee = null;
      this.getHrHandBookFileData();
      return;
    }
    if (data.length > 1) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getHrHandBookFileData();
          },
            500);
        }
      },
        1500);
    }
  }
}
